import React from 'react';
import { Router } from 'react-router-dom';

import { AuthProvider } from '../context/auth-context';
import Routes from './routes';
import history from './history';

const MainRoutes = () => {
  return (
    <AuthProvider>
      <Router history={history}>
        <Routes />
      </Router>
    </AuthProvider>
  );
};

export default MainRoutes;
